// extracted by mini-css-extract-plugin
export var button = "header-module--button--8a20a";
export var buttonSelected = "header-module--buttonSelected--9afe4";
export var containerBg = "header-module--containerBg--ba4c7";
export var icon = "header-module--icon--4bbbd";
export var menuDesktopButtons = "header-module--menuDesktopButtons--92c57";
export var redButton = "header-module--redButton--307d4";
export var separator = "header-module--separator--859ab";
export var siteLogo = "header-module--siteLogo--6cc5c";